import React from "react"

export function Archive(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      {...props}
    >
      <path
        d="M0.875 0H13.125C13.609 0 14 0.391016 14 0.875V1.75C14 2.23398 13.609 2.625 13.125 2.625H0.875C0.391016 2.625 0 2.23398 0 1.75V0.875C0 0.391016 0.391016 0 0.875 0ZM0.875 3.5H13.125V10.5C13.125 11.4652 12.3402 12.25 11.375 12.25H2.625C1.65977 12.25 0.875 11.4652 0.875 10.5V3.5ZM4.375 5.6875C4.375 5.92812 4.57188 6.125 4.8125 6.125H9.1875C9.42813 6.125 9.625 5.92812 9.625 5.6875C9.625 5.44688 9.42813 5.25 9.1875 5.25H4.8125C4.57188 5.25 4.375 5.44688 4.375 5.6875Z"
        fill="#6B7280"
      />
    </svg>
  )
}
